import React, {useState} from 'react';


function useCustomTable(props) {
  const [paginationProps, setPaginationProps] = useState({})
  const [tableSearchProps, setTableSearchProps] = useState({})
  const [tableFilterProps, setTableFilterProps] = useState({})
  const [tablePageLengthProps, setTablePageLengthProps] = useState({})
  const [sortByProps, setSortByProps] = useState({})

  return {
    tableProps: {setPaginationProps, setTableSearchProps, setTablePageLengthProps, setSortByProps, setTableFilterProps, ...props},
    paginationProps,
    tableSearchProps,
    tablePageLengthProps,
    sortByProps,
    tableFilterProps
  }
}


export default useCustomTable
